import Joi from 'joi';

import { FeatureItemValueTypeEnum } from '../../../../shared/modules/base/enums/feature-item-value-type.enum';
import { TenantFeatureItemTypeEnum } from '../../enums/tenant-feature-item-type.enum';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 */
export const tenantFeatureItemSchema = () =>
	Joi.object({
		// Type
		type: Joi.string()
			.valid(...Object.values(TenantFeatureItemTypeEnum))
			.required()
			.messages({
				'any.required': 'validations|tenant-feature-item-type|required',
				'any.only': 'validations|tenant-feature-item-type|invalid-value',
			}),
		// Value type
		valueType: Joi.string()
			.valid(...Object.values(FeatureItemValueTypeEnum))
			.optional(),
	})
		// Ignore extra fields
		.unknown();
